import React, { useContext } from 'react';
import styled from 'styled-components';
import { useInViewEffect } from '@oneaudi/feature-app-utils';
import { MoreOptionsDisclaimer } from './components/MoreOptionsDisclaimer';
import { Slider } from './components/Slider';
import { ContentContext } from './context/ContentContext';
import { UniversalStateContext } from './context/UniversalStateContext';
import { fetchCarline } from './utils/fetchCarline';
import { useFeatureAppEnv } from './context/FeatureAppEnvContext';
import { FAStateContextProvider } from './context/FAStateContext';
import ConsumptionAndEmission from './components/ConsumptionAndEmission';
import { ThreeDShowroom } from './components/3DShowroom';
import { FeatureSelector } from './components/selector/FeatureSelector';
import { SliderViewModeSwitch } from './components/SliderViewModeSwitch';
import { useTrackingManager } from './hooks/useTracking';
import { StageConfigureButton } from './components/StageConfigureButton';
import { CarlineOption } from './components/CarlineOption';

const FeatureApp: React.FC = () => {
  const content = useContext(ContentContext);
  const universalState = useContext(UniversalStateContext);
  const { 'gfa:locale-service': locale } = useFeatureAppEnv().featureServices;
  const carline = fetchCarline(content.carlineId, locale.countryCode, locale.language);

  const trackingManager = useTrackingManager();

  useInViewEffect(() => {
    if (carline && carline.name) {
      trackingManager.impression(content.carlineId);
    }
  });

  if (!universalState || !content || !carline) {
    return null;
  }
  const {
    streamDisplayOption: { show3dStream },
  } = content;

  return (
    <FAStateContextProvider carline={carline}>
      <Stage>
        <SliderViewModeSwitch />
        {show3dStream && <ThreeDShowroom />}
        <Slider />
        <FeatureSelector />
        <StageConfigureButton />
      </Stage>
      <CarlineInfoContainer>
        <CarlineOption />
        <MoreOptionsDisclaimer />
        <ConsumptionAndEmission />
      </CarlineInfoContainer>
    </FAStateContextProvider>
  );
};

const Stage = styled.div`
  position: relative;
`;

const CarlineInfoContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  padding: var(--spacing-relative-lg) var(--page-margin) var(--spacing-relative-xl);
`;

export default FeatureApp;
